import { csvParse, autoType } from 'd3-dsv';

export const colors = {
  'light': {
    'text': '#222',
    'muted': '#777',
    'pale': '#f0f0f0',
    'background': '#fff'
  },
  'dark': {
    'text': '#eee',
    'muted': '#bbb',
    'pale': '#333',
    'background': '#222'
  }
}

export function setColors(theme) {
  for (let color in colors[theme]) {
    document.documentElement.style.setProperty('--' + color, colors[theme][color]);
  }
}

export async function getData(url) {
  let response = await fetch(url);
  let string = await response.text();
	let data = await csvParse(string, autoType);
  return data;
}